// css
import style from "css/mobile.module.css";
// antd
import { Avatar, Badge, Button, ConfigProvider, Drawer, Menu } from "antd";
import { BellOutlined, MenuOutlined } from "@ant-design/icons";
// react
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
// redux
import { useSelector } from "react-redux";
// router
import { useNavigate } from "react-router-dom";
// svg
import { ReactComponent as Logo } from "asset/menu/logo.svg";
import { ReactComponent as CloseIcon } from "asset/common/close_popup.svg";
import { ReactComponent as MyPageIcon } from "asset/menu/mypage.svg";
import { ReactComponent as AddressIcon } from "asset/menu/address.svg";
import { ReactComponent as RecordIcon } from "asset/menu/record.svg";
import { ReactComponent as LogIcon } from "asset/menu/log.svg";
import { ReactComponent as NoticeIcon } from "asset/menu/notice.svg";
import { ReactComponent as RealtimeIcon } from "asset/menu/realtime.svg";
import { ReactComponent as MeetingIcon } from "asset/menu/meeting.svg";
import { ReactComponent as HotdeskingIcon } from "asset/menu/hotdesking.svg";
// import { ReactComponent as SettingIcon } from "asset/menu/setting.svg";
import AlarmBar from "./alarm/alarmBar";
import axios from "axios";
import { useTranslation } from "react-i18next";

/**
 * 파일명: header.js
 * 작성자: 권도훈
 * 작성일자: 25.02.12
 * 설명: 모바일 페이지 공통 헤더 및 사이드 메뉴
 */
function Header() {
  const payload = useSelector((state) => state.user);
  const { t } = useTranslation();

  // state
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isAlarmOpen, setIsAlarmOpen] = useState(false);
  const [pageName, setPageName] = useState("");

  const [alramdot, setalramdot] = useState(false);
  const [runcount, setruncount] = useState(true);

  const countalram = useCallback(() => {
    let config = {
      params: {
        TARGET_USER: payload.id,
      },
    };
    axios.get("/alram/countalram", config).then((res) => {
      if (res.status === 200) {
        if (res.data > 0) {
          setalramdot(true);
        } else {
          setalramdot(false);
        }
      }
    });
  }, [payload]);

  useEffect(() => {
    if (runcount) {
      if (payload.id !== "") {
        countalram();
        setruncount(false);
      }
    }
  }, [runcount, countalram, payload, isAlarmOpen, isAlarmOpen]);

  const alarmCloseHandler = () => {
    setruncount(true);
    setIsAlarmOpen(false);
  };
  const pathName = window.location.pathname;
  return (
    <>
      <header>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                colorPrimary: "#000",
                colorPrimaryHover: "#000",
                colorPrimaryActive: "#f8f8f8",
                // defaultBg: "#000",
                // defaultHoverBg: "#000",
                // defaultActiveBg: "#f8f8f8"
              },
              Drawer: {
                padding: 0,
              },
            },
          }}
        >
          <Button
            className={style.menu_btn_open}
            type="primary"
            size={37}
            icon={<MenuOutlined style={{ color: "#fff" }} />}
            onClick={() => {
              setIsShowMenu(!isShowMenu);
            }}
          />
        </ConfigProvider>

        <p className={style.title}>
          {pathName === "/app/meeting/room"
            ? t("MENU.회의실 현황")
            : t("MENU." + pageName)}
        </p>

        <Badge dot={alramdot} color="#1cb691" offset={[-4, 5]}>
          <Avatar
            style={{ backgroundColor: "#000" }}
            size={37}
            icon={<BellOutlined size={21} style={{ color: "#fff" }} />}
            onClick={() => setIsAlarmOpen(true)}
          />
        </Badge>
      </header>

      <MenuDrawer
        isShowMenu={isShowMenu}
        closeEvent={() => setIsShowMenu(false)}
        setPageName={(res) => setPageName(res)}
      />
      <AlarmBar
        isOpen={isAlarmOpen}
        close={alarmCloseHandler}
        payload={payload}
      />
    </>
  );
}

export default Header;

function MenuDrawer({ isShowMenu, closeEvent, setPageName }) {
  // selector
  const userInfo = useSelector((state) => state.user);
  const allowPageList = useSelector((state) => state.allowPage);

  // state
  const [init, setInit] = useState(true);
  const [menuList, setMenuList] = useState([]);
  const [openKeys, setOpenKeys] = useState("");
  const [selectedKeys, setSelectedKeys] = useState("");

  // navigate
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_CLIENT_URL + "app/";

  // 메뉴 항목 별 아이콘 설정정
  const setMenuIcon = useCallback((url) => {
    switch (url) {
      case "mypage":
        return <MyPageIcon />;
      case "calendar":
        return <MeetingIcon />;
      case "room":
        return <MeetingIcon />;
      case "hotdesking":
        return <HotdeskingIcon />;
      case "address":
        return <AddressIcon />;
      case "record":
        return <RecordIcon />;
      case "log":
        return <LogIcon />;
      case "notice":
        return <NoticeIcon />;
      case "realtime":
        return <RealtimeIcon />;
      default:
        return <></>;
    }
  }, []);

  // 페이지 이름 초기설정정
  const initPageName = useCallback(() => {
    const path = new URL(window.location.href).pathname;
    const pathList = path.replace("/app/", "").split("/");

    allowPageList.pages.forEach((item) => {
      if (pathList[0] !== item.MENU_URL) return;

      if (pathList.length === 1) {
        setPageName(item.MENU_NM);
        return;
      } else {
        allowPageList.pages.forEach((subItem) => {
          if (pathList[1] === subItem.MENU_URL) {
            setPageName(subItem.MENU_NM);
            return;
          }
        });
      }
    });
  }, [allowPageList.pages, setPageName]);

  // 메뉴 리스트 렌더링
  const renderMenuList = useCallback(() => {
    const list = [];

    allowPageList.pages.forEach((item) => {
      if (item.PAR_MENU_ID === "0") {
        list.push({
          key: item.MENU_ID,
          icon: setMenuIcon(item.MENU_URL),
          label: item.MENU_NM,
        });
      }
    });

    list.forEach((item) => {
      const children = [];

      allowPageList.pages.forEach((subItem) => {
        if (item.key === subItem.PAR_MENU_ID) {
          children.push({
            key: subItem.MENU_ID,
            label: subItem.MENU_NM,
          });
        }
      });

      if (children.length > 0) {
        item.children = children;
      }
    });

    return list;
  }, [allowPageList.pages, setMenuIcon]);

  // 초기 설정정
  useLayoutEffect(() => {
    if (init && allowPageList.pages.length > 0 && menuList.length === 0) {
      setMenuList(renderMenuList());
      initPageName();
      setInit(false);
    }
  }, [
    allowPageList.pages.length,
    init,
    initPageName,
    menuList.length,
    renderMenuList,
  ]);

  // 메뉴 탭 이벤트
  const onOpenChange = (openKeys) => {
    setOpenKeys(openKeys);
  };

  // 메뉴 선택 이벤트
  const onSelectMenu = ({ key }) => {
    setSelectedKeys([key]);

    allowPageList.pages.forEach((item) => {
      if (item.MENU_ID === key) {
        setPageName(item.MENU_NM);

        if (item.PAR_MENU_ID !== "0") {
          allowPageList.pages.forEach((subItem) => {
            if (subItem.MENU_ID === item.PAR_MENU_ID) {
              navigate(BASE_URL + subItem.MENU_URL + "/" + item.MENU_URL);
            }
          });
        } else {
          navigate(BASE_URL + item.MENU_URL);
        }
        closeEvent();
        return;
      }
    });
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          padding: 0,
          paddingLG: 0,
          paddingXS: 0,
        },
        components: {
          Menu: {
            itemColor: "#fff",
            itemHoverColor: "#e0ff8d",
            horizontalItemSelectedColor: "#e0ff8d",
            horizontalItemHoverColor: "#e0ff8d",
            itemSelectedColor: "#e0ff8d",
            subMenuItemSelectedColor: "#e0ff8d",
            itemHeight: "45px",

            // itemColor: "#fff",
            // itemHoverColor: "rgba(255, 255, 255, 0.7)",
            // horizontalItemHoverColor: "#e0ff8d",
            // itemSelectedColor: "#e0ff8d !important",
            // itemSelectedBg: "rgba(224, 255, 141, 0.24)",
            // controlItemBgActive: "rgba(224, 255, 141, 0.24)",
            // colorBgElevated: "#000000",
            // colorBorder: "#b4b4b4",
            // colorTextPlaceholder: "#909090",
          },
        },
      }}
    >
      <Drawer open={isShowMenu} closable={false} width="100%" placement="left">
        <section className={style.menu}>
          <div className={style.menu_header}>
            <Logo />
            <CloseIcon
              className={style.menu_btn_close}
              onClick={() => closeEvent()}
            />
          </div>

          <div className={style.menu_content}>
            <Menu
              mode="inline"
              onSelect={onSelectMenu}
              selectedKeys={selectedKeys}
              onOpenChange={onOpenChange}
              openKeys={openKeys}
              items={menuList}
              style={{
                backgroundColor: "#000",
                color: "#fff",
                fontSize: "17px",
                fontFamily: "Spoqa Han Sans Neo",
              }}
            />
          </div>

          <div className={style.menu_footer}>
            <article className={style.menu_user_article}>
              <p className={style.user_name}>{userInfo.name} 님</p>
              <p className={style.user_id}>{userInfo.id}</p>
            </article>
          </div>
        </section>
      </Drawer>
    </ConfigProvider>
  );
}
